import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { UserController } from 'src/controllers/user.controller'
import { UserDto } from 'src/dto/user.dto'

const useController = new UserController()

export function useGetUserList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<UserDto[], Error>({
    queryKey: ['getUserListFromFarm'],
    queryFn: () => useController.getUserListFromFarm(farmId!),
    enabled: !!farmId
  })
}
